import React from 'react';
import Wrapper from '../../components/Wrapper/Wrapper';
import { Redirect, Route, Switch } from "react-router-dom";
const Blank = () => (
  <Wrapper>
   <Switch>
    <Redirect to={{
      pathname:'/parties',
      state: {
        id: 1,
        pageTitle: 'Parties'
      }
    }} />
   </Switch>
  </Wrapper>
);
export default Blank;
